<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>模板名称</label>
                </div>
                <div class="form-value">
                    <span>{{payPhaseTpl.name}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人</label>
                </div>
                <div class="form-value">
                    <span>{{payPhaseTpl.creatorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间</label>
                </div>
                <div class="form-value">
                    <span>{{payPhaseTpl.createTime}}</span>
                </div>
            </div>
        </div>
        <div class="tabs-layout">
            <table class="custom-tbl error-prompt">
                <thead class="head">
                <tr class="row">
                    <th width="200" style="text-align: left">阶段名称</th>
                    <th style="text-align: left">支付比例(%)</th>
                    <th style="text-align: left">备注</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr v-for="(item,index) in payPhaseTpl.itemList" class="row">
                    <td style="text-align: left">{{item.name}}</td>
                    <td style="text-align: left">{{item.ratio}}</td>
                    <td style="text-align: left">{{item.desc}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import finacApi from '../../api/finac'

    export default {
        name: 'swb-pay-phase-tpl-detail',
        desc: '付款阶段模板详情',
        props: ['tplId'],
        data: function () {
            return {
                payPhaseTpl: {},
            }
        },
        created: function () {
            //
            this.getPayPhaseTplDetail();
        },
        methods: {
            getPayPhaseTplDetail: function () {
                let self = this;
                let postData = {};
                postData.tplId = self.tplId;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getPayPhaseTplById(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let payPhaseTpl = result.data;
                        let itemList = payPhaseTpl.itemList || [];
                        itemList.forEach(function (item) {
                            item.ratio = parseFloat(item.ratio).toFixed(2);
                        });
                        self.payPhaseTpl = Utils.merge({}, payPhaseTpl);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/payPhase/PayPhaseTplDetail.vue